const he = {
  // General
  appName: 'מנארה',
  appNameAr: 'منارة',
  appNameEn: 'MANARA',
  slogan: 'מכללת מנארה',
  switchLang: 'العربية',
  logout: 'התנתק',
  save: 'שמור',
  cancel: 'ביטול',
  add: 'הוסף',
  edit: 'עריכה',
  delete: 'מחיקה',
  search: 'חיפוש...',
  actions: 'פעולות',
  status: 'סטטוס',
  loading: 'טוען...',
  noData: 'אין נתונים להצגה',
  export: 'ייצוא',
  exportExcel: 'ייצוא לאקסל',
  exportPDF: 'ייצוא ל-PDF',
  filter: 'סינון',
  all: 'הכל',
  close: 'סגור',
  confirm: 'אישור',
  back: 'חזרה',
  details: 'פרטים',
  name: 'שם',
  email: 'דוא"ל',
  phone: 'טלפון',
  address: 'כתובת',
  date: 'תאריך',
  notes: 'הערות',
  send: 'שלח',

  // Sidebar
  dashboard: 'לוח בקרה',
  students: 'סטודנטים',
  tasks: 'משימות',
  courses: 'קורסים',
  lecturers: 'מרצים',
  finance: 'כספים',
  communication: 'תקשורת',
  leads: 'לידים',
  reports: 'דוחות',
  settings: 'הגדרות',
  schedule: 'מערכת שעות',

  // Dashboard
  activeStudents: 'סטודנטים פעילים',
  activeCourses: 'קורסים פעילים',
  newLeads: 'לידים חדשים',
  monthlyRevenue: 'הכנסות החודש',
  urgentTasks: 'משימות דחופות',
  todayEvents: 'אירועים היום',
  revenueChart: 'גרף הכנסות',
  upcomingEvents: 'אירועים קרובים',
  shekel: '₪',

  // Students
  studentList: 'רשימת סטודנטים',
  addStudent: 'הוסף סטודנט',
  firstName: 'שם פרטי',
  lastName: 'שם משפחה',
  dateOfBirth: 'תאריך לידה',
  nationalId: 'תעודת זהות',
  city: 'יישוב',
  program: 'תכנית/קורס',
  enrollmentDate: 'תאריך הרשמה',
  studentStatus: 'סטטוס סטודנט',
  candidate: 'מועמד',
  approved: 'מאושר',
  active: 'פעיל',
  frozen: 'מוקפא',
  graduated: 'סיים לימודים',
  enrolledCourses: 'קורסים רשומים',
  grades: 'ציונים',
  payments: 'תשלומים',
  commHistory: 'היסטוריית תקשורת',
  sendEmail: 'שלח דוא"ל',
  sendWhatsApp: 'שלח WhatsApp',

  // Documents
  documents: 'מסמכים',
  uploadDocument: 'העלאת מסמך',
  docType: 'סוג מסמך',
  fileName: 'שם הקובץ',
  uploadDate: 'תאריך העלאה',
  viewDoc: 'צפייה',
  downloadDoc: 'הורדה',
  deleteDoc: 'מחיקה',
  docTypes: {
    id_card: 'תעודת זהות',
    bagrut: 'תעודת בגרות',
    prev_studies: 'אישור לימודים קודמים',
    medical: 'אישור רפואי',
    passport_photo: 'תמונת פספורט',
    registration_contract: 'חוזה הרשמה',
    receipt: 'קבלה',
    other: 'אחר',
  },

  // Courses
  courseList: 'רשימת קורסים',
  addCourse: 'הוסף קורס',
  courseCode: 'קוד קורס',
  courseName: 'שם הקורס',
  lecturer: 'מרצה',
  semester: 'סמסטר',
  academicYear: 'שנה אקדמית',
  maxStudents: 'מקסימום סטודנטים',
  enrolled: 'רשומים',
  price: 'מחיר',
  room: 'כיתה',
  weeklySchedule: 'מערכת שעות שבועית',
  enrollStudent: 'רשום סטודנט',
  attendance: 'נוכחות',

  // Days
  sunday: 'ראשון',
  monday: 'שני',
  tuesday: 'שלישי',
  wednesday: 'רביעי',
  thursday: 'חמישי',
  friday: 'שישי',
  saturday: 'שבת',

  // Lecturers
  lecturerList: 'רשימת מרצים',
  addLecturer: 'הוסף מרצה',
  specialization: 'התמחות',
  contractType: 'סוג חוזה',
  hourlyRate: 'שכר לשעה',
  fullTime: 'מלא',
  partTime: 'חלקי',

  // Finance
  paymentList: 'רשימת תשלומים',
  addPayment: 'הוסף תשלום',
  amount: 'סכום',
  paidAmount: 'סכום ששולם',
  paymentStatus: 'סטטוס תשלום',
  paid: 'שולם',
  partial: 'חלקי',
  debt: 'חוב',
  paymentMethod: 'אמצעי תשלום',
  bankTransfer: 'העברה בנקאית',
  creditCard: 'כרטיס אשראי',
  cash: 'מזומן',
  check: 'שיק',
  receiptNumber: 'מספר קבלה',
  scholarships: 'מלגות והנחות',
  paymentReminder: 'תזכורת תשלום',
  totalRevenue: 'סה"כ הכנסות',
  totalDebt: 'סה"כ חובות',

  // Communication
  sendMessage: 'שלח הודעה',
  messageType: 'סוג הודעה',
  emailMessage: 'דוא"ל',
  whatsappMessage: 'WhatsApp',
  recipient: 'נמען',
  subject: 'נושא',
  message: 'הודעה',
  template: 'תבנית',
  templates: {
    payment_reminder: 'תזכורת תשלום',
    enrollment_confirmation: 'אישור הרשמה',
    schedule_update: 'עדכון מערכת שעות',
    general: 'הודעה כללית'
  },
  sendToGroup: 'שלח לקבוצה',
  messageHistory: 'היסטוריית הודעות',
  scheduledMessages: 'הודעות מתוזמנות',

  // Leads
  leadsList: 'רשימת לידים',
  addLead: 'הוסף ליד',
  interest: 'תחום עניין',
  source: 'מקור הגעה',
  stage: 'שלב',
  followUpDate: 'תאריך מעקב',
  convertToStudent: 'המר לסטודנט',
  stages: {
    interested: 'מתעניין',
    contacted: 'יצרנו קשר',
    meeting_scheduled: 'נקבעה פגישה',
    meeting_attended: 'הגיע לפגישה',
    applied: 'הגיש מועמדות',
    enrolled: 'נרשם',
    active_student: 'סטודנט פעיל'
  },
  sources: {
    facebook: 'פייסבוק',
    website: 'אתר',
    referral: 'המלצה',
    fair: 'יריד',
    whatsapp: 'ווטסאפ',
    other: 'אחר'
  },
  conversionReport: 'דוח המרה',

  // Prospects (מתעניינים)
  prospects: 'מתעניינים',
  prospectsList: 'רשימת מתעניינים',
  addProspect: 'הוסף מתעניין',
  requestedProgram: 'תכנית מבוקשת',
  prospectEntryDate: 'תאריך כניסה',
  branch: 'סניף',
  programNotes: 'הערות לתכנית',
  personalInfo: 'פרטים אישיים',
  followUpsTab: 'הערות ומעקב',
  addCommunication: 'הוסף תקשורת',
  addFollowUp: 'הוסף רשומת מעקב',
  handler: 'מי טיפל',
  actionTaken: 'מה נעשה',
  nextStep: 'השלב הבא',
  convertToLead: 'העבר ללידים',
  convertToProspect: 'העבר למתעניינים',
  confirmConvertToStudent: 'להעביר מתעניין זה לסטודנט? כל הנתונים והמסמכים יועברו.',
  confirmConvertToLead: 'להחזיר מתעניין זה לרשימת הלידים?',
  confirmConvertLeadToProspect: 'להעביר ליד זה לרשימת המתעניינים?',
  activeProspects: 'מתעניינים פעילים',
  prospectStatuses: {
    initial_contact: 'פנייה ראשונית',
    in_process: 'בתהליך בירור',
    documents_submitted: 'הגיש מסמכים',
    waiting_approval: 'ממתין לאישור',
    approved_for_registration: 'אושר להרשמה',
    rejected: 'נדחה',
    registered: 'נרשם',
  },

  // Action Performer
  performedBy: 'בוצע על ידי',
  actionPerformer: 'מבצע הפעולה',

  // Reports
  reportStudents: 'דוח סטודנטים פעילים',
  reportRevenue: 'דוח הכנסות',
  reportAttendance: 'דוח נוכחות',
  reportGrades: 'דוח ציונים',
  reportLecturers: 'דוח מרצים ושעות',
  reportLeads: 'דוח לידים והמרות',

  // Settings
  systemSettings: 'הגדרות מערכת',
  userManagement: 'ניהול משתמשים',
  collegeSettings: 'הגדרות מכללה',
  semesterManagement: 'ניהול סמסטרים',
  collegeName: 'שם המכללה',
  branches: 'סניפים',
  role: 'תפקיד',
  admin: 'מנהל',
  secretary: 'מזכירה',
  username: 'שם משתמש',
  password: 'סיסמה',

  // Schedule
  time: 'שעה',
  day: 'יום',

  // Billing & Payments
  billingSettings: 'סליקה ותשלומים',
  shakedSettings: 'הגדרות שקד (הוראות קבע)',
  placardSettings: 'הגדרות פלאכארד (אשראי)',
  terminalNumber: 'מספר מסוף',
  apiKey: 'מפתח API',
  apiUrl: 'כתובת API',
  testConnection: 'בדיקת חיבור',
  connectionSuccess: 'החיבור תקין!',
  connectionFailed: 'החיבור נכשל',
  chargeCard: 'גביית תשלום בכרטיס אשראי',
  createStandingOrder: 'הקמת הוראת קבע',
  sendPaymentLink: 'שליחת קישור לתשלום',
  installments: 'מספר תשלומים',
  description: 'תיאור',
  monthlyAmount: 'סכום חודשי',
  collectionDay: 'יום גבייה',
  numberOfMonths: 'מספר חודשים',
  bankAccount: 'חשבון בנק',
  bankNumber: 'מספר בנק',
  branchNumber: 'מספר סניף',
  accountNumber: 'מספר חשבון',
  accountHolder: 'שם בעל החשבון',
  paymentLinkUrl: 'קישור לתשלום',
  copyLink: 'העתק קישור',
  sendViaWhatsApp: 'שלח בווטסאפ',
  sendViaEmail: 'שלח בדואל',
  billingHistory: 'היסטוריית גביות',
  transactionId: 'מספר עסקה',
  transactionType: 'סוג עסקה',
  success: 'הצליח',
  failed: 'נכשל',
  pending: 'ממתין',
  collectPayment: 'גבה תשלום',
  createOrder: 'הקם הוראת קבע',
  sendLink: 'שלח קישור לתשלום',
  paymentPage: 'דף תשלום',
  payNow: 'שלם עכשיו',
  cardNumber: 'מספר כרטיס',
  expiryDate: 'תוקף',
  cvv: 'CVV',
  cardHolderName: 'שם בעל הכרטיס',
  paymentSuccess: 'התשלום בוצע בהצלחה!',
  paymentFailed: 'התשלום נכשל',

  // Digital Signatures
  digitalSignatures: 'חתימה דיגיטלית',
  sendForSignature: 'שלח לחתימה',
  signerName: 'שם החותם',
  signerEmail: 'מייל החותם',
  signerPhone: 'טלפון החותם',
  attachedMessage: 'הודעה מצורפת',
  selectDocument: 'בחר מסמך',
  signatureTracking: 'מעקב חתימות',
  sentTo: 'נשלח ל',
  sentDate: 'תאריך שליחה',
  signatureDate: 'תאריך חתימה',
  signed: 'נחתם',
  expired: 'פג תוקף',
  signPage: 'דף חתימה',
  drawSignature: 'צייר חתימה',
  fullName: 'שם מלא',
  idNumber: 'מספר ת.ז.',
  signAndConfirm: 'חתום ואשר',
  clearSignature: 'נקה חתימה',
  signatureSuccess: 'המסמך נחתם בהצלחה!',
  documentToSign: 'מסמך לחתימה',

  // Accounting
  accounting: 'הנהלת חשבונות',
  createInvoice: 'הפק חשבונית',
  createReceipt: 'הפק קבלה',
  invoice: 'חשבונית מס',
  invoiceReceipt: 'חשבונית מס קבלה',
  receiptDoc: 'קבלה',
  quote: 'הצעת מחיר',
  transactionDoc: 'חשבון עסקה',
  docNumber: 'מספר מסמך',
  customerName: 'שם לקוח',
  customerAddress: 'כתובת לקוח',
  customerPhone: 'טלפון לקוח',
  customerEmail: 'מייל לקוח',
  customerIdNumber: 'מספר ע.מ./ח.פ.',
  lineItems: 'פירוט שורות',
  itemDescription: 'תיאור',
  quantity: 'כמות',
  unitPrice: 'מחיר ליחידה',
  lineTotal: 'סה"כ',
  addLine: 'הוסף שורה',
  totalBeforeVat: 'סה"כ לפני מע"מ',
  vat: 'מע"מ 17%',
  totalWithVat: 'סה"כ כולל מע"מ',
  allDocuments: 'כל המסמכים',
  revenueReportMonthly: 'דוח הכנסות חודשי',
  revenueReportYearly: 'דוח הכנסות שנתי',
  newDocument: 'מסמך חדש',
  sendToCustomer: 'שלח ללקוח',
  year: 'שנה',
  month: 'חודש',
  total: 'סה"כ',
  count: 'כמות',

  // VoicEnter
  externalConnections: 'חיבורים חיצוניים',
  voicenterSettings: 'הגדרות וויססנטר (VoicEnter)',
  voicenterCustomerId: 'מספר לקוח וויססנטר',
  voicenterApiKey: 'מפתח API',
  voicenterApiUrl: 'כתובת API',
  voicenterMainPhone: 'מספר טלפון ראשי (קו יוצא)',
  callNow: 'חייג',
  callHistory: 'שיחות',
  calls: 'שיחות',
  todayCalls: 'שיחות היום',
  scheduleCallBtn: 'תזמן שיחה',
  listenRecording: 'האזן להקלטה',
  callTime: 'שעה',
  callDuration: 'משך שיחה',
  calledBy: 'מי התקשר',
  callDirection: 'כיוון',
  callStatus: 'סטטוס שיחה',
  outgoing: 'יוצאת',
  incoming: 'נכנסת',
  answered: 'ענה',
  no_answer: 'לא ענה',
  busy: 'תפוס',
  initiated: 'מתחיל',
  scheduled: 'מתוזמן',
  phoneCall: 'שיחת טלפון',
  scheduleCallTitle: 'תזמון שיחה',
  scheduledDate: 'תאריך',
  scheduledTime: 'שעה',
  callInitiated: 'השיחה התחילה!',
  callScheduled: 'השיחה תוזמנה בהצלחה!',
  incomingCallFrom: 'שיחה נכנסת מ',
  unknownCaller: 'מספר לא מזוהה',
  sec: 'שנ׳',
  documentName: 'שם המסמך',
  documentNamePlaceholder: 'למשל: הסכם לימודים',
  signatureMessagePlaceholder: 'הודעה שתצורף לבקשת החתימה',
  signHere: 'חתום כאן',
  resend: 'שלח שוב',
  document: 'מסמך',
  signedDate: 'תאריך חתימה',

  // Registration Forms
  registrationForms: 'טפסי רישום',
  sendRegistrationForm: 'שלח טופס רישום',
  registrationFormSent: 'טופס הרישום נשלח בהצלחה!',

  // Business core — Scheduling conflicts
  conflictTitle: 'התנגשות במערכת השעות',
  conflictLecturer: 'המרצה כבר משובץ בשיעור אחר בזמן זה',
  conflictRoom: 'החדר תפוס בזמן זה',
  conflictWith: 'התנגשות עם',
  saveAnyway: 'שמור בכל זאת',
  noConflicts: 'אין התנגשויות',
  checkingConflicts: 'בודק התנגשויות...',

  // Business core — Receipt on payment / PDF
  createReceiptPrompt: 'התשלום נרשם. ליצור קבלה עבורו?',
  createReceiptYes: 'צור קבלה',
  receiptCreated: 'הקבלה נוצרה',
  downloadPdf: 'הורד PDF',
  viewPdf: 'צפה ב-PDF',
  generatingPdf: 'מפיק PDF...',

  // Business core — Revenue grouping
  revenueBy: 'הכנסות לפי',
  byMonth: 'לפי חודש',
  bySemester: 'לפי סמסטר',
  byCourse: 'לפי קורס',
  linkToCourse: 'שייך לקורס',

  // Business core — Payment provider
  paymentProvider: 'ספק סליקה',
  chargeApproved: 'החיוב אושר',
  chargeDeclined: 'החיוב נדחה',

  // UX growth — Recruitment funnel
  recruitmentFunnel: 'משפך גיוס',
  funnelRegistrations: 'טפסים שהוגשו',
  funnelStudents: 'סטודנטים השנה',
  conversion: 'המרה',
  currentYearLabel: 'שנה"ל',

  // UX growth — KPI trends
  vsLastMonth: 'מול חודש קודם',
  trendUp: 'עלייה',
  trendDown: 'ירידה',

  // UX growth — Needs attention
  needsAttention: 'דורש טיפול',
  leadsNoFollowup: 'לידים ללא מעקב (מעל 3 ימים)',
  paymentsOverdue: 'תשלומים שעבר מועדם',
  tasksOverdue: 'משימות באיחור',
  registrationsPending: 'טפסים שנשלחו ולא הוגשו',
  openRecord: 'פתח',
  sendReminder: 'שלח תזכורת',
  allClear: 'הכל מטופל! אין פריטים הדורשים טיפול',
  remaining: 'יתרה',

  // UX growth — Empty states
  noItemsYet: 'עדיין אין נתונים כאן',
  emptyStudents: 'עדיין לא נוספו סטודנטים',
  emptyLeads: 'עדיין לא נוספו לידים',
  emptyProspects: 'עדיין לא נוספו מתעניינים',
  emptyTasks: 'עדיין לא נוספו משימות',
  emptyCourses: 'עדיין לא נוספו קורסים',
  emptyPayments: 'עדיין לא נרשמו תשלומים',
  createFirst: 'צור את הפריט הראשון',

  // UX growth — Global search & quick add
  globalSearchPlaceholder: 'חיפוש סטודנט / ליד / מתעניין...',
  searchNoResults: 'לא נמצאו תוצאות',
  quickAdd: 'הוספה מהירה',
  quickAddLead: 'ליד חדש',
  quickAddTask: 'משימה חדשה',
  quickAddStudent: 'סטודנט חדש',

  // UX growth — Sidebar groups
  groupMarketing: 'שיווק ורישום',
  groupAcademic: 'אקדמיה',
  groupManagement: 'ניהול',

  // UX growth — Lecturer portal
  lecturerPortal: 'פורטל מרצה',
  myCourses: 'הקורסים שלי',
  enterAttendance: 'הזן נוכחות',
  enterGrades: 'הזן ציונים',
  selectSession: 'בחר מפגש',
  saveAttendance: 'שמור נוכחות',
  saveGrades: 'שמור ציונים',
  grade: 'ציון',
  present: 'נוכח',
  absent: 'נעדר',
  noCoursesAssigned: 'לא שויכו לך קורסים',
  nextSession: 'המפגש הבא שלי',
  noUpcomingSession: 'אין מפגש קרוב',

  // UX growth v2 — KPI cards
  openLeads: 'לידים פתוחים',
  collectionThisMonth: 'גבייה החודש',
  openTasks: 'משימות פתוחות',
  overdueShort: 'באיחור',
  noFollowupShort: 'ללא מעקב',
  candidatesShort: 'מועמדים',
  quickAddProspect: 'מתעניין חדש',
};

export default he;
